import { render, staticRenderFns } from "./DealsBu.vue?vue&type=template&id=7a397051&scoped=true"
import script from "./DealsBu.vue?vue&type=script&lang=js"
export * from "./DealsBu.vue?vue&type=script&lang=js"
import style0 from "./DealsBu.vue?vue&type=style&index=0&id=7a397051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a397051",
  null
  
)

export default component.exports